<template>
  <aside class="journal-sidebar"
         :class="{'journal-sidebar-closed': !bigSidebar}">
    <header class="journal-top">
      <button type="button"
              @click="goJournals()"
              :class="{'btn-all-journals-closed device-text-small': !bigSidebar}"
              class="btn-centered btn-all-journals">
        <allJournalIcon :fill="bigSidebar ? '#109CF1' : 'rgba(0, 82, 127, 0.4)'" />
        <span :class="{'btn-hint btn-hint_left btn-hint_left_small': !bigSidebar}">{{$t('index.journal.sidebar.title')}}</span>
      </button>
      <button type="button"
              @click="toggleSidebarSize"
              :class="{'btn-back-closed': !bigSidebar}"
              class="btn-back">
        <chevronLeft  />
      </button>
    </header>

    <div class="journal-body" :class="{'journal-body-closed': !bigSidebar}">
      <button v-show="!bigSidebar"
              class="closed-title"
              @click="toggleSidebarSize">
        {{$t('index.journal.sidebar.title')}}
        <allJournalIcon :fill="'rgba(0, 82, 127, 0.4)'" />
      </button>
<!--      <ul>-->
<!--        <li v-for="(item, i) of 3" class="device-wrap" :class="{'device&#45;&#45;active': i === 1}">-->
<!--          <router-link :class="{'device-text-small': !bigSidebar}"  class="btn-centered btn-device" :to="`/journals/journal-${i}`">-->
<!--            <deviceIcon />-->
<!--            <span :class="{'btn-hint btn-hint_left btn-hint_left_small': !bigSidebar}">Устройство тест-{{i}}</span>-->
<!--          </router-link>-->
<!--        </li>-->
<!--      </ul>-->
<!--      <div class="device-wrap" :class="{'hide-list': !bigSidebar}">-->
<!--&lt;!&ndash;        <router-link  class="btn-centered btn-device" to="/journals/create">&ndash;&gt;-->
<!--          <button :class="{'device-text-small': !bigSidebar}"-->
<!--                  type="button"-->
<!--                  class="btn-centered btn-device btn-add-new-journal"-->
<!--                  @click="showAddNewJournalPopup">-->
<!--            <blueBGPlusIcon />-->
<!--            <span :class="{'btn-hint btn-hint_left btn-hint_left_small': !bigSidebar}">-->
<!--                  {{$t('index.journal.sidebar.addJournal')}}-->
<!--            </span>-->
<!--          </button>-->
<!--      </div>-->
      <div v-show="bigSidebar" class="trees-container journal-trees">
        <vue-tree-list :default-expanded="false"
                       class="nav-body"
                       :model="tree"
                       @click="clickInNode"
                       v-for="(tree, i) of trees"
                       :key="`tree-${i}`"
        >
          <span class="icon icon-single" slot="leafNodeIcon">
          <leaf-icon></leaf-icon>
        </span>
          <span class="icon icon-group" slot="treeNodeIcon">
          <group-icon></group-icon>
        </span>
          <span class="icon icon-mother" slot="delNodeIcon">
          <mother-icon></mother-icon>
        </span>
        </vue-tree-list>
      </div>
    </div>
  </aside>
</template>

<script>
  import allJournalIcon from '../../../components/Svg/journal/allJournalIcon'
  import chevronLeft from '../../../components/Svg/chevronLeft'
  import deviceIcon from '../../../components/Svg/journal/deviceIcon'
  import blueBGPlusIcon from '../../../components/Svg/journal/blueBG-PlusIcon'
  import closedSidebarLogo from '../../../components/Svg/journal/closedSidebarLogo'
  import {journalSidebar} from '../../../mixins/journalSidebar'

  import {mapMutations, mapGetters, mapState} from 'vuex'
  import {showOverlay} from '../../../mixins/utils/showOverlay'
  import addNewJournal from '../../Popups/journal/addNewJournal'
  import {VueTreeList, Tree, TreeNode} from 'vue-tree-list'
  import groupIcon from '../../../components/Svg/projects/navigator/groupIcon'
  import leafIcon from '../../../components/Svg/projects/navigator/leafIcon'
  import motherIcon from '../../../components/Svg/projects/navigator/motherIcon'
  import {navigatorMixin} from "../../../mixins/utils/navigatorMixin";

  export default {
    name: "journalSidebar",
    mixins: [journalSidebar, showOverlay, navigatorMixin],
    components: {
      allJournalIcon,
      chevronLeft,
      deviceIcon,
      blueBGPlusIcon,
      closedSidebarLogo,
      addNewJournal,
      VueTreeList,
      groupIcon,
      leafIcon,
      motherIcon
    },
    computed: {
      ...mapState({
        openNavigator: state => state.openProjectsNavigator,
        thing: state => state.things.device,
        allThingsTags: state => state.things.allThingsTags,
        allRolesTags: state => state.roles.allRolesTags,
        activeRolesTags: state => state.roles.activeRolesTags
      }),
      ...mapGetters({
        treeNavigator: 'projects/navigatorTree',
        allProjectsNavigatorTree: 'projects/allProjectsNavigatorTree',
        owned: 'things/tree'
      }),
      bigSidebar: {
        get() {
          return this.openNavigator
        },
        set(val) {
          this.toggleOpenNavigator(val)
        }
      },
      trees() {
        let trees = []
        for (let i = 0; i < this.allProjectsNavigatorTree.length; i++) {
          trees.push(new Tree([this.allProjectsNavigatorTree[i]]))
        }
        return trees
      },
    },
    methods: {
      ...mapMutations({
        showModal: 'popups/addNewJournal/SET_SHOW',
        toggleOpenNavigator: 'TOGGLE_OPEN_PROJECTS_NAVIGATOR'
      }),
      goJournals() {
        this.$router.push({ name: 'journal' })
      },
      clickInNode(node) {
        this.$emit('clickInNode', node)
      },
      toggleSidebarSize() {
        this.bigSidebar = !this.bigSidebar
        this.setShowJournalSidebar(this.bigSidebar)
      },
      showAddNewJournalPopup() {
        this.showOverlay(true)
        this.showModal(true)
      }
    },
    watch: {
      thing(val) {
        if (val) {
          this.setActiveNode(this.thing.name)
        }
      },
      trees(val) {
        this.setActiveNode(this.thing.name)
      }
    },
    mounted() {
      this.setActiveNode(this.thing.name)
    }
  }
</script>

<style lang="scss">
  .journal-body .closed-title {
    svg path {
      transition: all .3s;
    }
    &:hover {
      color: $blue !important;
      svg path {
        fill: $blue;
      }
    }
  }

  .journal-trees {
    background: $grey !important;
    .vtl-node-main {
      .vtl-operation {
        background: $grey !important;
      }
    }
  }

</style>

<style lang="scss" scoped>
  .trees-container {
    height: 100%;
    padding: 15px 20px;
    overflow: auto;
    @include scrollbal(10px);
  }

  .journal-sidebar {
    width: 260px;
    position: fixed;
    height: 100vh;
    z-index: 3;
    transition: all .3s;
  }
  .btn-centered {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    svg {
      margin-right: 10px;
    }
  }
  .device--active {
    background-color: #E9F0F4;
  }

  .journal-top {
    /*width: 260px;*/
    display: flex;
    height: 70px;
    .btn-all-journals {
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      background-color: $darkBlue;
      font-family: $mm;
      font-weight: 500;
      font-size: 14px;
      color: white;
    }
    .btn-back {
      width: 40px;
      background-color: $blue;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


  .journal-body {
    width: 100%;
    /*height: 100vh;*/
    /*height: 70%;*/
    height: calc( 100vh - 160px );
    background-color: #d7e3ea;
    overflow-y: scroll;

    @include scrollbal(2px);

    .device-wrap {
      padding: 15px 30px;
    }

    .btn-device {
      color: $darkBlue;
      font-family: $mm;
      font-weight: 500;
      font-size: 14px;
    }

    .btn-add-new-journal {
      color: $blue;
      font-family: $mm;
      font-weight: 500;
      font-size: 14px;
    }
  }
  // для закрытого сайд бара
  .journal-sidebar-closed {
    width: 70px;
    border-right: 1px solid rgba(0, 82, 127, 0.2);
  }
  .journal-top {
    .btn-all-journals-closed {
      padding: 0;
      justify-content: center;
      background-color: $ultraLightBlue;
      svg {
        margin: 0;
      }
    }
    .btn-back-closed {
      display: none;
    }
  }
  .journal-body-closed {
    background-color: #EFF3F6;
  }
  .journal-body, .journal-top {
    .hide-list {
      position: absolute;
      left: -260px;
      opacity: 0;
    }
    .closed-title {
      display: flex;
      align-items: center;
      width: 145px;
      height: 68px;
      position: absolute;
      left: -40px;
      top: 56px;
      transform: rotate(-90deg);
      color: rgba(0, 82, 127, 0.4);
      font-family: $msb;
      font-weight: 600;
      font-size: 14px;
      z-index: 10;
      svg {
        transform: rotate(90deg) translateX(1px);
        margin-left: 15px;
      }
    }
  }
  .journal-body, .journal-top {
    /*transition: all 1.45s;*/
    .device-text-small {
      font-size: 1px;
      transform: scaleX(0.3) translateX(-260px);
      /*transition: all .3s;*/
    }
    .btn-device {
      transition: all .3s;
    }
    .device-wrap {
      /*transition: all 0.3s;*/
    }
  }

// end
</style>
